export const FEATURED_PROPERTY_SOURCES = {
  TRIVAGO: {
    text: 'on Trivago',
    color: 'white',
    background: 'external.trivago',
  },
  TRIPADVISOR: {
    text: 'on TripAdvisor',
    color: 'white',
    background: 'external.tripAdvisor',
  },
  GOOGLEHOTELS: {
    text: 'on Google',
    color: 'white',
    background: 'external.google',
  },
  EMAIL: {
    text: 'from your Email',
    color: 'greys.charcoal',
    background: 'brand.secondary',
  },
  DEFAULT: {
    text: '',
    color: 'ui.badgeText',
    background: 'ui.badgeBackground',
  },
};

export const VALID_CAMPAIGN_SOURCES = ['Trivago', 'TripAdvisor', 'GoogleHotels', 'Email'];
